export default __webpack_public_path__ + "static/media/incidentscfg_card.dd1b68fc.jpg";